<script>
import each from 'lodash/each';
import VsHelp from 'viralstyle-ui/src/VsHelp';
import { generate } from 'randomstring';

export default {
  components: {
    VsHelp,
  },
  props: {
    value: [String, Number, Boolean, Date],
    disabled: Boolean,
    type: String,
    label: String,
    placeholder: String,
    hideLabel: [Boolean, String],
    labelLarge: [Boolean, String],
    optional: [Boolean, String],
    error: String, // use either this and errorVisible or errors that contain a visible property
    errorVisible: Boolean,
    errors: Array,
    helpHtml: String,
    white: [Boolean, String],
    autocomplete: String,
  },
  computed: {
    classes() {
      let classes = [];

      if (this.type === 'search') {
        classes = [...classes, 'pr-1_75', 'py-_5', 'border-2'];
      } else if (this.type === 'email-offers') {
        classes = [...classes, 'text-2xl', 'md_text-lg', 'py-1_5', 'md_py-1', 'pl-1_5', 'pr-3_5', 'md_pr-2_75', 'border-2'];
      } else {
        classes = [...classes, 'py-1 md_py-_75', 'border'];
      }

      if (this.type !== 'email-offers') {
        classes = [...classes, 'text-xl', 'md_text-base', 'px-1'];
      }

      if (this.white) {
        classes = [
          ...classes,
          'border',
          'border-white',
          'text-white',
          'focus_border-gray-200',
          'placeholder-gray-100',
          'bg-transparent',
        ];
      } else {
        classes = [
          ...classes,
          'border-brand-secondary-200',
          'text-brand-secondary',
          'focus_border-brand-secondary-400',
          'placeholder-brand-secondary-100',
        ];
      }

      return classes;
    },
    visibleErrors() {
      return this.errors ? this.errors.filter(error => error.visible) : [];
    },
    errorIds() {
      let ids = [];

      if (this.error && this.errorVisible) {
        ids = [generate()];
      } else if (this.errors) {
        each(this.visibleErrors, () => ids.push(generate()));
      }

      return ids;
    },
    inputType() {
      let type = 'text';

      if (this.type === 'emailOffers') {
        type = 'email'
      } else if (this.type === 'search') {
        type = 'text';
      } else if (this.type) {
        type = this.type;
      }

      return type;
    },
  },
  methods: {
    handleBlur(e) {
      this.$emit('search', { target: { value: this.value } })

      this.$emit('blur', e);
    },
  },
};
</script>

<template lang='pug'>
.text-left
  label.text-brand-secondary(
    v-if='label && !hideLabel',
    :class='{ "text-xl md_text-base": labelLarge }',
  ) {{label}} #[span.text-brand-secondary-100(v-if='optional') (optional)]
  .relative
    svg.absolute.svg.right-1.cursor-pointer(
      v-if='type === "search"',
      xmlns='http://www.w3.org/2000/svg',
      width='17',
      height='17',
      viewBox='0 0 20 20',
      :class='white ? "text-white" : "text-brand"',
      @click='$emit("search", { target: { value } })',
    )
      path.fill-current(
        d='M1.193 8.523c0-4.042 3.294-7.326 7.337-7.326 4.048 0 7.337 3.289 7.337 7.326 0 4.037-3.289 \
          7.33-7.337 7.33-4.043 0-7.337-3.289-7.337-7.33zM19.827 18.98l-4.861-4.86a8.492 8.492 0 0 0 2.093-5.592C17.06 \
          3.823 13.231 0 8.53 0 3.824 0 0 3.827 0 8.528c0 4.7 3.828 8.527 8.53 8.527 2.138 0 4.094-.789 \
          5.593-2.093l4.861 4.86c.116.116.27.178.422.178a.6.6 0 0 0 .421-1.02z',
      )

    svg.absolute.svg.right-1_5.md_right-1.cursor-pointer.svg--email(
      v-else-if='type === "email-offers"',
      xmlns='http://www.w3.org/2000/svg',
      viewBox='0 0 29 25',
      :class='white ? "text-white" : "text-brand"',
      @click='$emit("search", { target: { value } })',
    )
      path.fill-current(d='M0 25l29-12.5L0 0v9.722L20.714 12.5 0 15.278z')

    vs-help.svg.absolute.right-1(
      no-margin-bottom,
      v-else-if='helpHtml',
      :message='helpHtml',
    )
    svg.h-1.w-1.absolute.right-1.svg(
      v-else-if='helpHtml',
      viewBox='0 0 24 24',
      :class='white ? "text-white" : "text-brand"',
    )
      path.fill-current(d='M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z')

    input.buyer-text-input.w-full.focus_outline-none(
      :type='inputType',
      :value='value',
      :aria-label='label || placeholder',
      :aria-describedby='errorIds.length ? errorIds.join(" ") : null',
      :aria-invalid='errorIds.length ? "true" : "false"',
      :aria-disabled='disabled ? "true" : "false"',
      :class='classes',
      :placeholder='placeholder',
      :autocomplete='autocomplete',
      @input='$emit("input", $event)',
      @keyup.enter='$emit("search", { target: { value } })',
      @blur='handleBlur',
    )
  .mt-_5.text-error.text-sm(
    v-if='error && errorIds.length',
    :id='errorIds[0]',
  ) {{error}}
  .mt-_5.text-error.text-sm(
    v-else-if='visibleErrors.length',
    v-for='(error, index) in visibleErrors',
    :key='errorIds[index]',
    :id='errorIds[index]',
  ) {{error.text}}
</template>

<style>
@import '~import/index';

.svg {
  top: 50%;
  transform: translateY(-50%);

  &--email {
    height: 22px;
    width: 25px;

    @media(min-width: 768px) {
      width: 29px;
      height: 25px;
    }
  }
}

input[type=text]::-ms-clear {
  display: none;
}


input[type=tel]::-ms-clear {
  display: none;
}
</style>